module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/icons/icons.component.scss
// module id = ./src/app/icons/icons.component.scss
// module chunks = main